import { whatsappUrl } from "@/utils/whatsapp";
import { WA_MESSAGES, SANDO_LOGO, SANDO_HERO_VIDEO } from "@/mocks/site";
import { heroFallbackImage } from "@/mocks/menu";

export default function Hero() {
  return (
    <section
      id="inicio"
      className="relative flex min-h-[100svh] w-full items-center justify-center overflow-hidden"
    >
      <div className="absolute inset-0 h-full w-full">
        <img
          src={heroFallbackImage}
          alt="Sando de autor sobre pan de leche con tocino y ajonjolí"
          className="h-full w-full object-cover object-top"
        />
        {SANDO_HERO_VIDEO ? (
          <video
            className="absolute inset-0 h-full w-full object-cover object-top"
            src={SANDO_HERO_VIDEO}
            poster={heroFallbackImage}
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
            aria-label="Video de sandos de Sando by Cerón"
          />
        ) : null}
      </div>

      <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50" />

      <span
        className="absolute right-8 top-1/2 hidden -translate-y-1/2 select-none font-heading text-[10rem] leading-none text-background-50/10 lg:block"
        aria-hidden="true"
      >
        職人
      </span>

      <div className="relative z-10 flex w-full flex-col items-center px-5 text-center md:px-8">
        <img
          src={SANDO_LOGO}
          alt="Logotipo oficial de Sando by Cerón"
          className="animate-fade-in h-24 w-auto drop-shadow-[0_2px_16px_rgba(0,0,0,0.35)] md:h-32"
        />

        <p className="animate-fade-up mt-8 font-heading text-4xl italic text-background-50 md:text-6xl">
          Tradición entre panes
        </p>

        <p
          className="animate-fade-up mt-6 max-w-2xl text-base leading-relaxed text-background-100 md:text-lg"
          style={{ animationDelay: "120ms" }}
        >
          Sandos de autor de la chef Diana Cerón. Pan de leche, producto de granja y sabores
          orientales. A domicilio en Armenia.
        </p>

        <div
          className="animate-fade-up mt-10 flex w-full flex-col items-center gap-4 sm:w-auto sm:flex-row"
          style={{ animationDelay: "240ms" }}
        >
          <a
            href={whatsappUrl(WA_MESSAGES.general)}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex min-h-[52px] w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-8 text-base font-medium text-background-50 transition-all duration-300 hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-whatsapp-line text-xl" aria-hidden="true" />
            Pedir por WhatsApp
          </a>
          <a
            href="#carta"
            className="inline-flex min-h-[52px] w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/70 px-8 text-base font-medium text-background-50 transition-colors duration-300 hover:bg-background-50 hover:text-foreground-950 sm:w-auto"
          >
            Ver la carta
          </a>
        </div>
      </div>

      <a
        href="#carta"
        aria-label="Bajar a la carta"
        className="absolute bottom-7 left-1/2 z-10 flex -translate-x-1/2 flex-col items-center gap-2 text-background-100"
      >
        <span className="text-[11px] uppercase tracking-[0.3em]">Scroll</span>
        <span className="flex h-9 w-5 justify-center rounded-full border border-background-50/60 pt-1.5">
          <span className="animate-scroll-dot h-1.5 w-1.5 rounded-full bg-background-50" />
        </span>
      </a>
    </section>
  );
}